import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";
import Solar from "../../assets/Images/Solar Panel.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      fontSize: "2vh",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
     "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
  paper: {
    background: "#FFFFFF",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: "12px",
  },
  paper1: {
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px #0123B421",
    borderRadius: "12px",
    height: "12vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "2vh",
    fontWeight: "500",
  },
  cardHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: "1.7vh",
  },
  image: {
    width: "100%",
    height: "28vh",
    objectFit: "contain",
  },
  dataCard: {
    height: "100%",
    padding: "1vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();
  const [equipmentData, setEquipmentData] = useState({});
  const [fdata, setFdata] = useState("all");
  const [fid, setFId] = useState("all");
  const [floor, setFloor] = useState([]);

  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    api.dashboard
      .getMetricData(buildingID)
      .then((res) => {
        const sorted = res.sort((a, b) => a.name.localeCompare(b.name));
        setFloor(sorted);
      })
      .catch((err) => console.log(err));

    api.floor
      .cpmGetDevData()
      .then((res) => {
        const solarOnly = {
          NONGL_SS_SOLAR_PV_PLANT: res["NONGL_SS_SOLAR_PV_PLANT"],
        };
        setEquipmentData(solarOnly);
      })
      .catch((err) => console.log(err));
  }, [buildingID]);

  const selectedType = "NONGL_SS_SOLAR_PV_PLANT";

  const devices = equipmentData[selectedType]
    ? Object.entries(equipmentData[selectedType]).sort((a, b) =>
        a[1].name.localeCompare(b[1].name)
      )
    : [];

  const handleFloorChange = (name, id) => {
    setFId(id);
    setFdata(name);
  };

  // ✅ SAFE FORMAT FUNCTION
  const formatValue = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    const num = parseFloat(value);
    return !isNaN(num) ? num.toFixed(2) : "-";
  };

  const DataCard = ({ voltageLabel, currentLabel, voltage, current }) => (
    <Card className={classes.paper} style={{}}>
      <Grid container spacing={1}>
        <Grid item xs={6} style={{ textAlign: "center", fontWeight: "600", fontSize: "1.8vh", marginBottom: "0.5vh" }}>
          {voltageLabel} [V]
        </Grid>
        <Grid item xs={6} style={{ textAlign: "center", fontWeight: "600", fontSize: "1.8vh", marginBottom: "0.5vh" }}>
          {currentLabel} [A]
        </Grid>
        <Grid item xs={6}>
          <Card className={classes.paper1}>
            {formatValue(voltage)}
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card className={classes.paper1}>
            {formatValue(current)}
          </Card>
        </Grid>
      </Grid>
    </Card>
  );

  const PhaseCard = ({ phaseLabel, voltage, current }) => (
    <Card className={classes.paper}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div className={classes.cardHeading} style={{ textAlign: "left", fontSize: "2vh", fontWeight: 800 }}>
            {phaseLabel}
          </div>
        </Grid>

        <Grid item xs={6}>
          <div style={{ textAlign: "center", fontWeight: 600, fontSize: "1.8vh" }}>
            Voltage [V]
          </div>
        </Grid>
        <Grid item xs={6}>
          <div style={{ textAlign: "center", fontWeight: 600, fontSize: "1.8vh" }}>
            Current [A]
          </div>
        </Grid>

        <Grid item xs={6}>
          <Card className={classes.paper1}>{formatValue(voltage)}</Card>
        </Grid>
        <Grid item xs={6}>
          <Card className={classes.paper1}>{formatValue(current)}</Card>
        </Grid>
      </Grid>
    </Card>
  );

  const MetricCard = ({ label, value, unit }) => (
    <Card className={classes.paper}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div style={{ textAlign: "center", fontWeight: 800, fontSize: "2vh" }}>{label}</div>
        </Grid>
        <Grid item xs={12}>
          <div style={{ textAlign: "center", fontWeight: 800, fontSize: "1.9vh", marginTop: "0.4vh" }}>{formatValue(value)} {unit || ""}</div>
        </Grid>
      </Grid>
    </Card>
  );

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {/* Floor Dropdown */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
          <FormControl
            variant="filled"
            size="small"
            style={{ width: "100%", backgroundColor: "#eeeef5" }}
          >
            <Select value={fdata} className={classes.select} disableUnderline>
              <MenuItem
                value="all"
                onClick={() => handleFloorChange("all", "all")}
              >
                All Floors
              </MenuItem>
              {floor.map((_item) => (
                <MenuItem
                  key={_item.id}
                  value={_item.name}
                  onClick={() => handleFloorChange(_item.name, _item.id)}
                >
                  {_item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Device Cards */}
        <Grid container item xs={12} spacing={2}>
          {devices
            .filter(([_, deviceInfo]) =>
              fid === "all" ? true : deviceInfo?.Equipment_Group === fid
            )
            .map(([deviceId, deviceInfo]) => {
              const attrs = deviceInfo?.Eqp_Attributes || {};

              return (
                <Grid item xs={12} key={deviceId}>
                  <Card className={classes.paper} style={{ minHeight: "auto" }}>
                    <Grid container spacing={2}>
                      {/* Device Name */}
                      <Grid item xs={12}>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "2.2vh",
                            textAlign: "left",
                          }}
                        >
                          {deviceInfo?.name || "-"}
                        </div>
                      </Grid>

                      {/* Image */}
                      <Grid item xs={12} md={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img
                          src={Solar}
                          alt="Solar"
                          className={classes.image}
                        />
                      </Grid>

                      {/* Data Cards - 2x2 + 1 Layout */}
                      <Grid item xs={12} md={9}>
                        <Grid container spacing={2}>
                          {/* Phase 1/2/3 summary cards */}
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={4}>
                                <PhaseCard
                                  phaseLabel="Phase 1"
                                  voltage={attrs?.Solar_Phase_Volt_1?.presentValue/10}
                                  current={attrs?.Solar_Phase_Current_1?.presentValue}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <PhaseCard
                                  phaseLabel="Phase 2"
                                  voltage={attrs?.Solar_Phase_Volt_2?.presentValue/10}
                                  current={attrs?.Solar_Phase_Current_2?.presentValue}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <PhaseCard
                                  phaseLabel="Phase 3"
                                  voltage={attrs?.Solar_Phase_Volt_3?.presentValue/10}
                                  current={attrs?.Solar_Phase_Current_3?.presentValue}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          {/* Phase 1..3 already shown above in PhaseCard — avoid duplicate DataCards */}
                          <Grid item xs={12} sm={6} md={6}>
                            <DataCard
                              voltageLabel="Voltage 1"
                              currentLabel="Current 1"
                              voltage={attrs?.Solar_PV_Volt_1?.presentValue/10}
                              current={attrs?.Solar_PV_Current_1?.presentValue}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <DataCard
                              voltageLabel="Voltage 2"
                              currentLabel="Current 2"
                              voltage={attrs?.Solar_PV_Volt_2?.presentValue/10}
                              current={attrs?.Solar_PV_Current_2?.presentValue}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <DataCard
                              voltageLabel="Voltage 3"
                              currentLabel="Current 3"
                              voltage={attrs?.Solar_PV_Volt_3?.presentValue/10}
                              current={attrs?.Solar_PV_Current_3?.presentValue}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <DataCard
                              voltageLabel="Voltage 4"
                              currentLabel="Current 4"
                              voltage={attrs?.Solar_PV_Volt_4?.presentValue/10}
                              current={attrs?.Solar_PV_Current_4?.presentValue}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <DataCard
                              voltageLabel="Voltage 5"
                              currentLabel="Current 5"
                              voltage={attrs?.Solar_PV_Volt_5?.presentValue /10}
                              current={attrs?.Solar_PV_Current_5?.presentValue}
                            />
                          </Grid>
                          {/* Metric cards row (values with headings beneath) */}
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={3}>
                                <MetricCard
                                  label="Solar Active Power"
                                  value={attrs?.Solar_Active_Power?.presentValue}
                                  unit="kW"
                                />
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <MetricCard
                                  label="Today Solar Energy"
                                  value={attrs?.Solar_Today_Solar_Energy?.presentValue}
                                  unit="kWh"
                                />
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <MetricCard
                                  label="Total Solar Energy"
                                  value={attrs?.Solar_Total_Solar_Energy?.presentValue}
                                  unit="kWh"
                                />
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <MetricCard
                                  label="Frequency"
                                  value={attrs?.Solar_Freq?.presentValue/100}
                                  unit="Hz"
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </div>
  );
}